import { openDB } from 'idb'

const SHARE_DB_NAME = 'weReaderShareTarget'
const SHARE_DB_VERSION = 1
const SHARE_STORE_NAME = 'pendingEpubShares'
const inMemoryPendingShareFiles: File[] = []

type PendingShareRecord = {
  id?: number
  name: string
  type: string
  lastModified: number
  blob: Blob
  createdAt: number
}

const openShareTargetDb = async () => {
  return openDB(SHARE_DB_NAME, SHARE_DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(SHARE_STORE_NAME)) {
        db.createObjectStore(SHARE_STORE_NAME, { keyPath: 'id', autoIncrement: true })
      }
    },
  })
}

export const queuePendingSharedFiles = (files: File[]): void => {
  if (files.length === 0) {
    return
  }

  inMemoryPendingShareFiles.push(...files)
}

export const dequeuePendingSharedEpubFiles = async (): Promise<File[]> => {
  const queuedFiles = inMemoryPendingShareFiles.splice(0, inMemoryPendingShareFiles.length)

  try {
    const db = await openShareTargetDb()
    const tx = db.transaction(SHARE_STORE_NAME, 'readwrite')
    const store = tx.objectStore(SHARE_STORE_NAME)

    const records = (await store.getAll()) as PendingShareRecord[]
    await store.clear()
    await tx.done

    const sharedFiles = records
      .filter((record) => record?.blob instanceof Blob && Boolean(record.name))
      .map(
        (record) =>
          new File([record.blob], record.name || 'shared.epub', {
            type: record.type || 'application/epub+zip',
            lastModified: record.lastModified || Date.now(),
          })
      )
    return [...queuedFiles, ...sharedFiles]
  } catch (error) {
    console.error('Failed to read pending shared EPUB files:', error)
    return queuedFiles
  }
}
